import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import tituloSeccion from "@/components/cliente/ui/tituloSeccion.vue";
Vue.component('tituloSeccion', tituloSeccion)
import botonEnlace from "@/components/cliente/ui/botonEnlace.vue";
Vue.component('botonEnlace', botonEnlace)
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')